export function formatCurrency(input: number | string, currency: string = '€'): string {
  if (typeof input === 'string') {
    input = parseFloat(input);
  }
  if (isNaN(input) || input === null || input === undefined) {
    return '0';
  }
  const parts = input.toFixed(2).split('.');
  const integerPart = [...parts[0]].reverse().join('').match(/.{1,3}/g)?.join(' ');
  return `${integerPart ? [...integerPart].reverse().join('') : ''}${currency}`; // Without decimal
}

export const formatNumberWithSpaces = (value: string): string => value.replaceAll(/\B(?=(\d{3})+(?!\d))/g, ' ');

export function formatSurface(input: number, decimals: number = 0): string {
  return `${input.toFixed(decimals).replaceAll(/\d(?=(\d{3})+$)/g, '$& ').replace('.', ',')}m²`;
}

export function formatValue(input: number | string | null | undefined, decimals: number = 0): string {
  const parsedInput = parseFloat(input as string);
  if (isNaN(parsedInput)) {
    return '0';
  }
  // &nbsp to not break the line
  return parsedInput.toFixed(decimals).replaceAll(/\d(?=(\d{3})+$)/g, '$& ').replace('.', ',');
}

// Date

export const Months = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

export const ShortMonths = [
  'Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin',
  'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.',
];

export const formatDate = (dateString: string) => {
  const dateObject = new Date(dateString);
  return `${dateObject.getDate().toString().padStart(2, '0')}/${(dateObject.getMonth() + 1).toString().padStart(2, '0')}/${dateObject.getFullYear()}`;
};

export const formatDateWithTime = (dateString: string) => {
  const dateObject = new Date(dateString);
  return `${dateObject.getDate().toString().padStart(2, '0')}/${(dateObject.getMonth() + 1).toString().padStart(2, '0')}/${dateObject.getFullYear()} à ${dateObject.getHours().toString().padStart(2, '0')}:${dateObject.getMinutes().toString().padStart(2, '0')}`;
};

export const formatDateStr = (date: any) => {
  const dateObject = new Date(date);
  return `${dateObject.getDate()} ${Months[dateObject.getMonth()]} ${dateObject.getFullYear()}`;
};

// Function to extract text content from a potential HTML-like object
export const formatToText = (elem: React.ReactNode | Element | string): string => {
  if (elem == null) {
    return '';
  }

  // Handle string or number
  if (typeof elem === 'string' || typeof elem === 'number') {
    return elem.toString();
  }

  // Handle arrays
  if (Array.isArray(elem)) {
    return elem.map(formatToText).join('');
  }

  if (typeof elem === 'object' && 'props' in elem) {
    // Check if the element looks like a SelectMe component
    if ('options' in elem.props && 'value' in elem.props) {
      const { value } = elem.props;

      // Handle multiple and single select cases
      if (Array.isArray(value)) {
        return value.map((v) => v.label || v).join(', ');
      } if (value && typeof value === 'object') {
        return value.label || '';
      }
      return value ? value.toString() : '';
    }

    const { children } = elem.props;
    if (children) {
      return formatToText(children);
    }
  }

  // Handle DOM elements
  if (elem instanceof Element) {
    return elem.textContent || '';
  }

  // Handle other cases (like boolean values)
  return '';
};

/**
 * Format date string to database format "YYYY-MM-DD HH:MM:SS" in local time for API submission
 * This should ONLY be used when submitting to the API, not during form entry
 */
export const formatDateTimeForDb = (isoString: string): string => {
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

/**
 * Updates time in a Date object without any string conversion
 * This preserves the original Date object format for form state
 */
export const updateTimeInDate = (date: Date, hours: number, minutes: number): Date => {
  const newDate = new Date(date);
  newDate.setHours(hours, minutes);
  return newDate;
};
